import { useModulePermission } from '../../../hooks/usePermission';
import { Modules } from '../../../constants/permissions';

export function useD504Permission(moduleId: string = Modules.PWD504) {
  const perms = useModulePermission(moduleId);

  return {
    canView: perms.canView,
    canApprove: perms.canApprove,
    hasAnyPermission: perms.hasAnyPermission,
  };
}
